export default {
  shareScreenTitle: 'Share your screen',
  shareScreenDescription: 'Choose a screen or window to share with the call.',
  screens: 'Screens',
  windows: 'Windows',
  builtInDisplay: 'Built-in display',
  display: 'Display {{number}}',
  noWindows: 'No other windows are open.',
  screenAccessNeeded:
    'Macro needs Screen Recording access. Turn on Macro in System Settings › Privacy & Security › Screen & System Audio Recording, then reopen Macro.',
  share: 'Share',
  shareFailed: "Couldn't share your screen. Try again.",
};
